import { defineStore } from 'pinia'
import { resolvePlantsApiRoot } from '@/utils'

const API_ROOT = resolvePlantsApiRoot()
export const PAGE_SIZE = 10

export const usePlantStore = defineStore('plant-store', {
    state: () => (
        { plants: [],
          selected_plant: null,
          animals: [],
          selected_animals: JSON.parse(localStorage.getItem("selected_animals")) || [],
          lang: localStorage.getItem("lang") || 'pl',
          langs: ['en', 'pl'],
          q: localStorage.getItem("q") || '',
          loved_plant_ids: JSON.parse(localStorage.getItem("loved_plant_ids")) || [],
          is_loved_plants: JSON.parse(localStorage.getItem("is_loved_plants")) || false,
          is_safe: JSON.parse(localStorage.getItem("is_safe")) || false,
          rows: 0,
          current_page: localStorage.getItem("current_page") || 1
        }),
    getters: {
      
    },
    actions: {
        async getPlants() {
            if (this.is_loved_plants && !this.loved_plant_ids.length) {
                this.plants = []
                this.rows = 0
                return
            }
            const params = new URLSearchParams()
            params.set('page', this.current_page)
            const query = (this.q || '').trim()
            if (query) {
                params.set('q', query)
            }
            if (this.is_loved_plants) {
                params.set('ids', this.loved_plant_ids.join(','))
            }
            if (this.is_safe) {
                params.set('is_toxic', '-1')
                params.set('animal_ids', this.selected_animals.join(','))
            }
            const response = await fetch(`${API_ROOT}api/plants?${params}`)
            if (!response.ok) {
                this.plants = []
                this.rows = 0
                return
            }
            const data = await response.json()
            this.plants = data.results
            this.rows = data.count
            window.scrollTo({
                top: 0,
                behavior: 'instant'
            })
        },
        async getAnimals() {
            fetch(`${API_ROOT}api/animals`)
            .then(response => response.json())
            .then(data => {
                this.animals = data.results
                if(localStorage.getItem("selected_animals") === null){
                    this.selected_animals =  data.results.map((val) => val.id)
                }
            })
        },
        async postReport(data) {
            try {
                const response = await fetch(`${API_ROOT}api/plant_reports`, {
                    method: 'POST',
                    body: JSON.stringify({
                        plant: data.plant ?? null,
                        email: data.email,
                        description: data.description,
                        website: data.website || '',
                        form_ts: data.form_ts,
                    }),
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                    },
                })
                return response.status
            } catch (e) {
                return 0
            }
        }
    }
  })